import axios from '../../api/axiosInstance';
import { STATUS, extractErrorInfo } from './sharedfunction';

const BASE = `${process.env.REACT_APP_API_URL || ''}/super-admin`;

/**
 * Get organizations with credit/balance info (Script Creator, Test Launch, Script Manager).
 * @returns {Promise<{ status: number, data?: Array, error?: string }>}
 */
export async function getOrgsWithBalances() {
  try {
    const response = await axios.get(`${BASE}/orgs`, { withCredentials: true });
    if (response?.data?.success) {
      const data = response?.data?.data;
      return {
        status: STATUS.SUCCESS,
        data: Array.isArray(data) ? data : [],
        message: response?.data?.message,
      };
    }
    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
    };
  } catch (error) {
    return extractErrorInfo(error);
  }
}

/**
 * Top up credits for an org/section.
 * @param {Object} body
 * @param {string} body.orgId - Organization UUID
 * @param {string} body.section - script_creator | test_launch | script_manager
 * @param {number} body.amount - Positive integer
 * @param {string} [body.reason] - Optional reason
 * @returns {Promise<{ status: number, data?: object, error?: string }>}
 */
export async function topupCredits(body) {
  try {
    const response = await axios.post(`${BASE}/credits/topup`, body, {
      withCredentials: true,
    });
    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data,
        message: response?.data?.message,
      };
    }
    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
    };
  } catch (error) {
    return extractErrorInfo(error);
  }
}

/**
 * Get credit adjustment history for an org, optionally filtered by section.
 * @param {string} orgId - Organization UUID
 * @param {string} [section] - Optional: script_creator | test_launch | script_manager
 * @returns {Promise<{ status: number, data?: Array, error?: string }>}
 */
export async function getCreditHistory(orgId, section) {
  try {
    const params = new URLSearchParams({ orgId });
    if (section) params.set('section', section);
    const response = await axios.get(`${BASE}/credits/history?${params.toString()}`, {
      withCredentials: true,
    });
    if (response?.data?.success) {
      const data = response?.data?.data;
      return {
        status: STATUS.SUCCESS,
        data: Array.isArray(data) ? data : [],
        message: response?.data?.message,
      };
    }
    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
    };
  } catch (error) {
    return extractErrorInfo(error);
  }
}
